import { MdDeleteOutline, MdShare } from "react-icons/md"
import { Row, Col, Modal, Form, Button } from "react-bootstrap";
import { FaFilePdf, FaEye, FaFolder } from "react-icons/fa"
import { useNavigate } from "react-router-dom";
import LoadingBar from "../toaster/loader/loader";
import { useState } from "react";
import Dropdown from 'react-bootstrap/Dropdown'
import { MultiSelect } from "react-multi-select-component";
import schoolServices from "../../../services/school_services";
import hospitalServices from "../../../services/hospital.services";
import { getHospitalSharedDoc, getSchoolSharedDoc, showSuccessMessage } from "../../../services/utils";
export const MyCreatedFilesStructure = (props) => {
    const navigate = useNavigate()
    const [shareModal, setShareModal] = useState({ state: false, modalName: "" })
    const role = localStorage.getItem("PageTittle")
    const [loadin, setloading] = useState(false)
    const [shareitem, setShareItem] = useState({ item_id: "", reciver_role: "" })
    const [schoolHospitalList, setschoolHospitalList] = useState([])
    const [recieverlist, setReciverlist] = useState([])

    const getSchoolHospitalList = (listType) => {
        setloading(true)
        if (role === "School") {
            if (listType === "Hospital") {
                schoolServices.getHospitalList().then(res => {
                    setloading(false)
                    res.data.data && res.data.data.length > 0 &&
                        res.data.data.map(curr => {
                            setschoolHospitalList(prevState => ([...prevState,
                            {
                                label: curr.hospitalInfo.hospital_name,
                                value: curr.hospitalInfo.user_id
                            }]))
                        })
                    setShareModal({ ...shareModal, state: !shareModal.state, modalName: listType })
                }).catch(err => setloading(false))
            }
            else {
                schoolServices.getRegSchools().then(resp => {
                    setloading(false)
                    resp.data.data && resp.data.data.length > 0 &&
                        resp.data.data.map(curr => {
                            setschoolHospitalList(prevState => ([...prevState,
                            {
                                label: curr.school_name,
                                value: curr._id

                            }]))
                        })
                    setShareModal({ ...shareModal, state: !shareModal.state, modalName: listType })
                })
            }
        }
        else if (role === "Hospital") {
            if (listType === "Hospital") {
                hospitalServices.getHospitalList().then(res => {
                    setloading(false)
                    res.data.data && res.data.data.length > 0 &&
                        res.data.data.map(curr => {
                            setschoolHospitalList(prevState => ([...prevState,
                            {
                                label: curr.hospitalInfo.hospital_name,
                                value: curr.hospitalInfo.user_id
                            }]))
                        })
                    setShareModal({ ...shareModal, state: !shareModal.state, modalName: listType })
                }).catch(err => setloading(false))
            }
            else {
                hospitalServices.getSchoolList().then(resp => {
                    setloading(false)
                    resp.data.data && resp.data.data.length > 0 &&
                        resp.data.data.map(curr => {
                            setschoolHospitalList(prevState => ([...prevState,
                            {
                                label: curr.school_name,
                                value: curr._id

                            }]))
                        })
                    setShareModal({ ...shareModal, state: !shareModal.state, modalName: listType })
                }).catch(err => setloading(false))
            }
        }
    }


    return (

        <Row>
            {loadin &&
                <LoadingBar />
            }
            {
                props.shardFiles && props.shardFiles.length > 0 ?
                    props.shardFiles.filter((res) => res?.type === "folder").map(curr => {
                        return (
                            <Col sm="3" >
                                <div className="file_card mb-3" style={{ position: "relative" }}>
                                    <div style={{ cursor: "pointer" }} className="flnm_wrp" onClick={() => { navigate(`/school-files/${curr._id}/${curr.createdBy_id}`) }}>
                                        <div className="fldr_icn txt_prpl">
                                            <FaFolder />
                                        </div>
                                        <h5>
                                            {curr?.name}
                                        </h5>
                                    </div>

                                    {/* <p>900 files</p> */}


                                    <span className="delete_folder">

                                        <MdDeleteOutline

                                            onClick={(e) => {
                                                e.preventDefault()
                                                const obj = {
                                                    id: curr._id,
                                                    type: curr.type
                                                }
                                                props.deleteFile(obj)
                                            }} />

                                        {/* <Dropdown className="border-remove" style={{
                                            marginLeft: "12px", top: "-23px", fontSize: "12px"
                                        }} >
                                            <Dropdown.Toggle variant="" id="dropdown-basic">
                                                <MdShare />
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                                <Dropdown.Item onClick={() => {
                                                    setShareItem({ ...shareitem, item_id: curr._id, reciver_role: "school" })
                                                    getSchoolHospitalList("School")


                                                }}>School</Dropdown.Item>
                                                <Dropdown.Item onClick={() => {
                                                    setShareItem({ ...shareitem, item_id: curr._id, reciver_role: "hospital" })
                                                    getSchoolHospitalList("Hospital")

                                                }} >Hospital</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown> */}
                                    </span>
                                </div>

                            </Col>
                        )
                    })
                    :
                    <Col sm="12">
                        <div className="file_card mb-3" style={{ textAlign: "center" }}>

                            No Folder or Files
                        </div>
                    </Col>
            }
            {

                props.shardFiles && props.shardFiles.length > 0 &&
                props.shardFiles.filter((res) => res?.type === "file")
                    .map(curr => {
                        return (
                            <Col sm="12">
                                <div className="file_card mb-3 crd_orng d-flex justify-content-between align-items-center" >
                                    <div className="d-flex">
                                        <div className="fl_icn txt_orng">
                                            <FaFilePdf />
                                        </div>
                                        <h6 style={{ marginLeft: "15px" }}>
                                        {curr?.name &&
                                            curr.name.substring(0, curr.name.indexOf("-"))
                                        }
                                        </h6>
                                    </div>
                                    <h6>
                                        {curr?.size}kb
                                    </h6>

                                    <div className="txt_orng d-flex" style={{ marginRight: "20px", cursor: "pointer" }}>
                                        <div>
                                            <FaEye onClick={(e) => {
                                                e.preventDefault()
                                                if (role === 'Hospital') {
                                                    getHospitalSharedDoc({
                                                        document: curr?.name,
                                                        type: "cstm_file"
                                                    }).then(resp => {
                                                        setloading(false)
                                                    }).catch(err => {
                                                        setloading(false)
                                                    })
                                                } else {
                                                    getSchoolSharedDoc({
                                                        document: curr?.name,
                                                        type: "cstm_file"
                                                    }).then(resp => {
                                                        setloading(false)
                                                    }).catch(err => {
                                                        setloading(false)
                                                    })
                                                }
                                            }} />
                                        </div>
                                        <div style={{ marginLeft: "15px", color: "#e68831", fontSize: "18px" }}>
                                            <MdDeleteOutline onClick={(e) => {
                                                const obj = {
                                                    id: curr._id,
                                                    type: curr.type
                                                }
                                                props.deleteFile(obj)

                                            }} />

                                            {/* <Dropdown style={{
                                                marginLeft: "12px", top: "-23px", fontSize: "12px"
                                            }} >
                                                <Dropdown.Toggle variant="" id="dropdown-basic">
                                                    <MdShare />
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu>
                                                    <Dropdown.Item>School</Dropdown.Item>
                                                    <Dropdown.Item >Hospital</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown> */}


                                            {/* <Dropdown className="border-remove" style={{
                                                marginLeft: "12px", top: "-23px", fontSize: "12px"
                                            }} >
                                                <Dropdown.Toggle variant="" id="dropdown-basic">
                                                    <MdShare />
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu>
                                                    <Dropdown.Item onClick={() => {
                                                        setShareItem({ ...shareitem, item_id: curr._id, reciver_role: "school" })
                                                        getSchoolHospitalList("School")

                                                    }}>School</Dropdown.Item>
                                                    <Dropdown.Item onClick={() => {
                                                        setShareItem({ ...shareitem, item_id: curr._id, reciver_role: "hospital" })
                                                        getSchoolHospitalList("Hospital")
                                                    }} >Hospital</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown> */}

                                        </div>


                                    </div>


                                </div>
                            </Col>
                        )
                    })
            }

            <Modal show={shareModal.state} onHide={() => {
                setschoolHospitalList([])
                setReciverlist([])
                setShareModal({ ...shareModal, state: !shareModal.state })
            }} className="main_modl">
                <Modal.Header closeButton>
                    <Modal.Title className="text_theme">
                        List of {shareModal.modalName}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="prfl_flds">
                        <Form>
                            <Form.Group controlId="formFile" className="mb-3">
                                <Form.Label>Please Select {shareModal.modalName}</Form.Label>
                                <MultiSelect
                                    className="multi_slct"
                                    options={schoolHospitalList}
                                    value={recieverlist}
                                    onChange={setReciverlist}
                                    labelledBy="Select"
                                    required
                                />
                            </Form.Group>

                            <Form.Group
                                controlId="formFile"
                                className="mb-3 mui_dtpickr"
                            >

                            </Form.Group>
                            <div className="text-center">
                                <Button
                                    className="btn_theme mt-4"
                                    variant=""
                                    onClick={() => {
                                        let Ids = []
                                        if (recieverlist.length > 0) {
                                            recieverlist.map(curr => {
                                                Ids.push(curr.value)
                                            })
                                        }
                                        props.shareFolders({
                                            custom_file_id: shareitem.item_id,
                                            shared_to: shareitem.reciver_role,
                                            shared_users: Ids
                                        })
                                    }}
                                >
                                    Share
                                </Button>
                            </div>
                        </Form>
                    </div>
                </Modal.Body>
            </Modal>

        </Row >



    )
}